import {useLocation} from "react-router-dom";
import NavBarProfil from "../../components/NavBarProfil/NavBarProfil";
import "./Favoris.scss";
import CardFavoris from "../../components/CardFavoris/CardFavoris";
import {useEffect, useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

function Favoris() {
    const location = useLocation();
    const {favoris} = location.state || {};

    const [tableauObjet, setFavoris] = useState([]);

    useEffect(() => {
        setFavoris(favoris || []);
        document.title = "Mes favoris";
    }, [favoris]);

    return (
        <div className="body-page-favoris">
            <NavBarProfil></NavBarProfil>
            <div className="container-right-favoris">
                <div className="client-orders-header">
                    <h1>Mes Favoris</h1>
                    <p>Retrouvez ici tous les articles que vous avez aimés.</p>
                </div>
                
                {tableauObjet.length > 0 ? (
                    <div className="favoris-grid">
                        {tableauObjet.map((favori) => (
                            <CardFavoris
                                key={favori.idProduct || favori.clientId}
                                coverArticle={favori.coverArticle}
                                prixArticle={favori.prixArticle}
                                nomArticle={favori.nomArticle}
                                idProduct={favori.idProduct}
                                setFavoris={setFavoris}
                                favoris={tableauObjet}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="empty-orders">
                        <FontAwesomeIcon icon={faHeart} style={{ fontSize: "4rem", color: "#cbd5e1", marginBottom: "1rem" }} />
                        <h3>Aucun favori pour le moment</h3>
                        <p>Parcourez la boutique et ajoutez des articles à vos favoris !</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Favoris;
